<div #stickyOuterTableHeader
  class="c--outer-table"
  [ngStyle]="{
    height: tableHeadingHeight + 'px',
    top: stickyDifference + 'px',
    transform: 'translateX(' + tableScrollLeft + 'px)'
  }"
>
  <div #stickyTableHeader class="c--table is-table-flex {{scrolled ? 'is-sticky' : ''}}">
    @if (isMobile$) {
      <div #checkboxWrapper class="c__actions-wrapper">
        @if (!lastProduct && canCompare) {
          <sd-form checkbox
            #checkboxCompare
            id="comparatorShowDifferencesMobile"
            (checkedChange)="toggleComparator($event)"
            [brand]="brand"
            [labelTitle]="('comparator.differences' | translate) || '...'"
            [checked]="compareOnLoad"
            nameField="compareDifferences"
            [required]="false"
          />
        }
      </div>
    }
    <table #comparatorTable role="presentation">
      <caption class="is-visually-hidden">
        {{('comparator.title' | translate) || '...' }}
      </caption>
      <tbody>
        <tr>
          @if (!isMobile$) {
            <td class="c__actions-cell">
              <div #checkboxWrapper class="c__actions-wrapper">
                @if (!lastProduct && canCompare) {
                  <sd-form checkbox
                    [brand]="brand"
                    (checkedChange)="toggleComparator($event)"
                    #checkboxCompare
                    id="comparatorShowDifferences"
                    [labelTitle]="('comparator.differences' | translate) || '...'"
                    [checked]="compareOnLoad"
                    nameField="compareDifferences"
                    [required]="false"
                  />
                }
              </div>
            </td>
          }
          @for (product of entries; track product.code) {
            <td class="c__headings is-product">
              @if (!readonly) {
                <button sd-button-icon
                  [brand]="brand ? brand : product?.brand"
                  (click)="onDelete($index)"
                  icon="icon-trash"
                  [size]="iconSize"
                  [buttonIconTitle]="('comparator.delete' | translate) || '...'"
                  [titleHidden]="true"
                  [attr.aria-label]="('comparator.delete' | translate) || '...'"
                ></button>
              }
              <sd-product-card
                [brand]="brand ? brand : product?.brand"
                [isSSR]="isSSR"
                [indexFollow]="product?.indexFollow !== undefined ? product?.indexFollow : true"
                [isSmall]="true"
                [largeTitle]="!isMobile$"
                class="{{promotedProduct && $index === (promotedProduct  - 1) ? 'is-promoted' : ''}}"
                (cart)="onAddToCart(product.code)"
                (notify)="onNotify(product.code)"
                (productSellerModal)="toggleProductSellerModal($event)"
                (productClicked)="onProductClick($event)"
                [isMinified]="scrolled"
                [productInfo]="product"
                (openRecommendedPriceModal)="onOpenRecommendedPriceModal()"
              />
              @if (($index + 1 === promotedProduct)) {
                <sd-tag
                  [brand]="brand ? brand : product?.brand" [tagData]="promotedProductTag"
                  class="c__promoted-tag"
                />
              }
            </td>
          }
          @if (entries.length < maxProducts && !readonly) {
            <td class="c__headings c__add">
              <a sd-button
                (click)="onAdd()"
                [brand]="brand"
                [isSecondary]="true"
                [isSmall]="true"
                icon="icon-plus"
              >
                <span>{{ ("comparator.addProduct" | translate) || '...' }}</span>
              </a>
            </td>
          }
        </tr>
      </tbody>
    </table>
  </div>
</div>

@if (!readonly) {
  <sd-accordion-group #accordionGroup [closeOthers]="false" [clickOutsideToClose]="false">
    @for (column of newColumns; track column) {
      <sd-accordion
        [title]="$first ? ('comparator.mainCharacteristics' | translate) : (classifications[$index]?.name)"
        [titleLevel]="2"
        class="{{column.hidden ? 'is-visually-hidden' : ''}}"
        [theme]="themesTextEnum.brand"
        [hasNoPadding]="true"
        [brand]="brand"
        [iconSize]="iconSize"
        iconNameOpened="icon-arrow-up"
        iconNameClosed="icon-arrow-down"
        [isDisabled]="$first"
        [isOpened]="$first"
        [iconPos]="positionEnum.left"
      >
        <sd-table
          [titleLevel]="2"
          [brand]="brand"
          (scroll)="onTableScroll($event)"
          class="is-table-flex"
          [entries]="newEntries[$index]"
          [maxColumn]="maxProducts"
          [columns]="column"
        />
      </sd-accordion>
    }
  </sd-accordion-group>
} @else if (isReadOnlyAccordion) {
  <sd-accordion-group #accordionGroup [closeOthers]="false" [clickOutsideToClose]="false">
    @for (column of readonlyAccordionColumns; track column) {
      <sd-accordion
        [title]="$first ? ('comparator.mainCharacteristics' | translate) : (classifications[$index]?.name)"
        [titleLevel]="2"
        class="{{column.hidden ? 'is-visually-hidden' : ''}}"
        [theme]="themesTextEnum.brand"
        [hasNoPadding]="true"
        [brand]="brand"
        [iconSize]="iconSize"
        iconNameOpened="icon-arrow-up"
        iconNameClosed="icon-arrow-down"
        [isDisabled]="$first"
        [isOpened]="$first"
        [iconPos]="positionEnum.left"
      >
        <sd-table
          [titleLevel]="2"
          [brand]="brand"
          (scroll)="onTableScroll($event)"
          class="is-table-flex"
          [entries]="readonlyAccordionEntries[$index]"
          [columns]="column"
        />
      </sd-accordion>
    }
  </sd-accordion-group>
} @else {
  <sd-table
    [brand]="brand"
    [titleLevel]="2"
    (scroll)="onTableScroll($event)"
    class="is-table-flex"
    #staticComparatorTable
    [entries]="readonlyEntries"
    [maxLine]="maxLine"
    [columns]="readonlyColumns"
    (more)="highlightPromotedProduct(true)"
  />
}

@if (readonly && promotedProduct > 0 && promotedProduct <= entries?.length) {
  <div class="c__selected-table"></div>
}
